import React from "react";
import { useTranslation } from "react-i18next";
import { z } from "zod";

import { Button } from "../ui/button";
import { Form, FormField, FormItem, FormMessage, useForm } from "../ui/form";
import { Input } from "../ui/input";

export default function ForgotPasswordForm() {
  const { t } = useTranslation("common");
  const form = useForm({
    schema: z.object({
      email: z.string().email(),
    }),
  });
  const handleSubmit = form.handleSubmit((data) => {});
  return (
    <Form {...form}>
      <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <Input
                {...field}
                placeholder={t("Auth.forgot_password_email_placeholder")}
              />
              <FormMessage />
            </FormItem>
          )}
        />
        <Button type="submit" variant="brand">
          {t("Auth.forgot_password_submit_button")}
        </Button>
      </form>
    </Form>
  );
}
